import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, Field, formValueSelector } from 'redux-form';
import { RadioGroup, SubaccountTypeaheadWrapper, TextFieldWrapper } from 'src/components';
import { Box, Stack } from 'src/components/matchbox';
import { required } from 'src/helpers/validation';

/**
 * Component produces the follow redux form fields
 * If newWebhook
 * - assignTo 'master' | 'all' | 'subaccount'
 * - subaccount if assignTo === 'subaccount'
 *
 * If !newWebhook
 * - subaccount TextField | typeahead (disabled)
 */
export class SubaccountSection extends Component {
  componentDidUpdate(prevProps) {
    const { assignTo, formName, change } = this.props;

    // Clear subaccount value if switching away from subaccount
    if (assignTo !== 'subaccount' && prevProps.assignTo === 'subaccount') {
      change(formName, 'subaccount', null);
    }
  }

  renderCreate() {
    const { assignTo, disabled } = this.props;

    const createOptions = [
      { label: 'Events from Primary and all Subaccounts', value: 'all', disabled },
      { label: 'Events from Primary Account only', value: 'master', disabled },
      { label: 'Events from a Single Subaccount', value: 'subaccount', disabled }
    ];

    const typeahead =
      assignTo === 'subaccount' ? (
        <Box ml="500">
          <Field
            name="subaccount"
            component={SubaccountTypeaheadWrapper}
            validate={required}
            data-track={true}
            helpText="This assignment is permanent."
          />
        </Box>
      ) : null;

    return (
      <Stack space="300">
        <Field
          component={RadioGroup}
          name="assignTo"
          label="Event Source"
          options={createOptions}
          data-track={true}
          display="block"
        />
        {typeahead}
      </Stack>
    );
  }

  renderEdit() {
    const { subaccount } = this.props;
    let component = SubaccountTypeaheadWrapper;

    // On 'primary only' or 'primary and all' webhooks
    if (typeof subaccount === 'string') {
      component = TextFieldWrapper;
    }

    return (
      <Field
        component={component}
        name="subaccount"
        label="Event Source"
        helpText="This assignment is permanent."
        disabled
        data-track={true}
      />
    );
  }

  render() {
    return this.props.newWebhook ? this.renderCreate() : this.renderEdit();
  }
}

SubaccountSection.propTypes = {
  newWebhook: PropTypes.bool,
  assignTo: PropTypes.oneOf(['master', 'all', 'subaccount']),
  change: PropTypes.func
};

const mapStateToProps = (state, props) => {
  const selector = formValueSelector(props.formName);
  return {
    assignTo: selector(state, 'assignTo'),
    subaccount: selector(state, 'subaccount')
  };
};

export default connect(mapStateToProps, { change })(SubaccountSection);
